import React from 'react';
import { Field } from 'formik';
import { CheckboxProps as CheckboxPropsType, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import {
  CardHcd,
  Document,
} from '@maiia/model/generated/model/api-patient/api-patient';
import Checkbox from '@/components/molecules/Formik/Checkbox';
import { useTranslation } from '@/src/i18n';

interface Props {
  card: CardHcd;
  documentId?: string;
  CheckboxProps?: CheckboxPropsType;
}
const SharedData: React.FC<Props> = ({
  card,
  documentId,
  CheckboxProps = {},
}) => {
  const { t } = useTranslation();
  const documents = useSelector<any, Document[]>(
    state => state.documents.items,
  );
  const currentdocument = documents.find(item => item.id === documentId);
  const sharedInfoList =
    currentdocument?.sharedInformation?.practitionerDestinationSet;

  const sharedInfo = sharedInfoList?.find(
    item =>
      item.practitionerId === card?.professional?.practitionerId &&
      (item.centerId === card?.center?.id ||
        item.centerId === card?.center?.parentCenter?.id),
  );
  if (sharedInfo) {
    const sharedDate = dayjs(sharedInfo.sharedDateTime).format('DD/MM/YY');
    return (
      <Typography
        color="text.medium"
        variant="body2"
        textAlign="center"
        component="span"
      >
        <Typography
          component="span"
          color="text.medium"
          sx={{ display: { sm: 'inline' }, fontSize: '12px' }}
        >
          {t('shared_on')}
        </Typography>
        {sharedDate}
      </Typography>
    );
  }
  return (
    <Field
      component={Checkbox}
      id={card.id}
      value={card.id}
      data-testid="checkbox"
      {...CheckboxProps}
    />
  );
};
export default SharedData;
